
import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import TrackingScans from '@/features/shipment-history/components/details/trackingDetails/TrackingScans.vue';
import { TrackingDetailsType } from '@/features/shipment-history/types';
import TrackingDetailsSkeleton from '@/features/shipment-history/components/details/trackingDetails/TrackingDetailsSkeleton.vue';
import HistoryNoResults from '@/features/shipment-history/components/HistoryNoResults.vue';
import { getDisplayCarrierCode } from '@/features/common/helpers/carrier';

@Component({
  components: {
    TrackingScans,
    TrackingDetailsSkeleton,
    HistoryNoResults,
  },
})
export default class TrackingDetails extends Vue {
  @Prop({ required: true }) trackingDetails!: TrackingDetailsType;

  @Prop({ default: '' }) selectedService!: string;

  @Prop({ default: false }) isLoading!: boolean;

  @Prop({ default: false }) large!: boolean;

  get displayCarrierCode(): string {
    if (!this.trackingDetails) return '';
    return getDisplayCarrierCode(this.trackingDetails.carrierCode, this.selectedService);
  }

  get isFedEx(): boolean {
    return this.trackingDetails?.carrierCode === 'FedEx';
  }
}
